(ns common.eid)

(defn- parse-long-safe
  [s]
  #?(:clj
     (try
       (Long/parseLong s)
       (catch Throwable _
         nil))
     :cljs
     (let [n (js/parseInt s 10)]
       (when-not (js/isNaN n)
         n))))

(defn- parse-legacy-eid-string
  [s]
  (or (parse-long-safe s)
      (some->> s
               (re-find #"(\d+)$")
               second
               parse-long-safe)))

(defn eid [entity]
  (or (:db/id entity)
      (when (number? entity)
        entity)
      (when (string? entity)
        (or (parse-legacy-eid-string entity)
            entity))))
